import { NgModule } from '@angular/core';
import { DynamicModule } from 'ng-dynamic-component';

import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { SharedModule } from 'shared/shared.module';

import { RenderLayoutComponent } from './render-layout/render-layout.component';
import { RenderLayoutSlotComponent } from './render-layout-slot/render-layout-slot.component';
import { RenderPieceComponent } from './render-piece/render-piece.component';
import { RenderSliceComponent } from './render-slice/render-slice.component';
import { RenderSliceSlotComponent } from './render-slice-slot/render-slice-slot.component';


@NgModule({
  imports: [
    RenderSharedModule,
    SharedModule,
    DynamicModule,
    LazyLoadModule
  ],
  declarations: [
    RenderLayoutComponent,
    RenderLayoutSlotComponent,
    RenderSliceComponent,
    RenderSliceSlotComponent,
    RenderPieceComponent,
    RenderLayoutSlotComponent,
    RenderLayoutComponent,
  ],
  exports: [
    RenderLayoutComponent,
    RenderLayoutSlotComponent,
    RenderSliceComponent,
    RenderSliceSlotComponent,
    RenderPieceComponent,
    RenderLayoutSlotComponent,
    RenderLayoutComponent,
  ]
})
export class RenderBlocksModule {}
